(function ($) {


    require('../jquery-plugins/select2-without-above.js');
    let lineRidesStops = [
        {id: 'Szczecin', name: 'Szczecin'},
        {id: 'Gol', name: 'Szczecin Lotnisko Goleniów'},
    ];

    //ask user browser for location
    const user_location = {lat: 53.42, lng: 14.56};
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
            user_location.lat = position.coords.latitude;
            user_location.lng = position.coords.longitude;
        });
    }

    function backofficeCall(operationName, variables, query, callback) {
        $.ajax({
            type: "POST",
            url: formTranslateConfigs.backoffice_url + "api/graphql",
            contentType: "application/json",
            data: JSON.stringify({
                operationName: operationName,
                variables: variables,
                query: query
            }),
            success: callback
        });
    }

    function backofficeGetAutocomplete(value, callback) {
        const searchMapPlaceInput = {
            input: value,
            language: $("body").attr('data-lang'),
            currentLatitude: user_location.lat,
            currentLongitude: user_location.lng,
            radius: 10,
            onlyAddresses: true
        };
        const query = `
query searchMapAutocomplete($searchMapPlaceInput: SearchMapPlaceInput!) {
    searchMapAutocomplete(searchMapPlaceInput: $searchMapPlaceInput) {
        description,types,placeId
    }
}`;
        backofficeCall('searchMapAutocomplete', {searchMapPlaceInput: searchMapPlaceInput}, query, function(response){
            callback({data: response.data.searchMapAutocomplete.map(place => ({
                id: place.placeId,
                start_place: place.description,
                start_is_airport: !place.types.includes('geocode'),
            }))});
        });
    }


    $( document ).ready(function() {
        if(!!jQuery.cookie('liniowe_cookie')){
            var cookieValue = jQuery.cookie('liniowe_cookie');


            var cookieJson = JSON.parse(cookieValue);

            $(".liniowe-input-od").attr('data-id', cookieJson.start_place);
            $(".liniowe-input-od").attr('data-name', cookieJson.start_place_name);
            $(".liniowe-input-od").val(cookieJson.start_place_name);

            $(".liniowe-input-do").attr('data-id', cookieJson.end_place);
            $(".liniowe-input-do").attr('data-name', cookieJson.end_place_name);
            $(".liniowe-input-do").val(cookieJson.end_place_name);
            $(".liniowe-input-do").prop('disabled', false);


            $(".liniowe-odjazd").val(cookieJson.odjazd);
            $(".liniowe-powrot").val(cookieJson.powrot);


            $("#liniowe-select-passager").val(cookieJson.passengers_number);
            $("#liniowe-input-passager").val(cookieJson.passengers_number);
            $("#liniowe-input-passager-span").html(cookieJson.passengers_number);
            $("#liniowe-input-passager").attr('data-value', cookieJson.passengers_number);

            if(parseInt(cookieJson.passengers_number) > 1){
                $("#liniowe-input-passager-span").find(".passagers-suggest-box-minus").addClass("active");
            }

            jQuery.removeCookie('liniowe_cookie');

        }
    });

    $(document).on('click', '.followme-frontpage-form-box-form-select-box', function () {
        $(".followme-frontpage-form-box-form-select-box").removeClass("active");
        var selectBox = $(this);
        selectBox.addClass("active");
        $(".followme-frontpage-form-box").find("h1").html(selectBox.attr('data-title-h1'));
        $(".followme-frontpage-hero").css('background-image', 'url(' + selectBox.attr('data-background-url') + ')');

        $(".followme-frontpage-form-box-form-inputarea").find("form").addClass("display-none");
        $("#" + selectBox.attr('data-type') + "-form").removeClass("display-none");
    });


    $(document).on('click', '.followme-frontpage-form-input-icon', function (e) {
        var inputFocus = $(this).parent().find("input");
        var divFocus = $(this).parent().find(" > div");


        if (!inputFocus.is(":focus")) {
            inputFocus.click();
            inputFocus.focus();
        } else {
            inputFocus.blur();
        }


    });


    // AJAX call for autocomplete
    $(document).ready(function () {


        $(".liniowe-input-od").keyup(function () {
            $(".liniowe-input-od").removeAttr("data-id");
            $(".liniowe-input-od").removeAttr("data-name");

            if ($(this).val().length > 2) {
                var sugesstionHtml = '<ul id="liniowe-input-od-suggesstion-box-list">';

                $.each(lineRidesStops, function (index, row) {
                    sugesstionHtml += '<li data-id="' + row.id + '"';
                    sugesstionHtml += '>' + row.name + '</li>';
                });
                sugesstionHtml += "</ul>";
                $("#liniowe-input-od-suggesstion-box").html(sugesstionHtml);
                $("#liniowe-input-od-suggesstion-box").show();
            } else {
                $("#liniowe-input-od-suggesstion-box").hide();
            }
        });

        $(document).on('click', '#liniowe-input-od-suggesstion-box-list li', function () {


            var htmlInputVal = $(this).html();
            var linieOdInput = $(".liniowe-input-od");
            $("#liniowe-input-od-suggesstion-box").hide();
            linieOdInput.val(htmlInputVal);
            linieOdInput.attr('data-id', $(this).attr('data-id'));
            linieOdInput.attr('data-name', htmlInputVal);


            var linieDoInput = $(".liniowe-input-do");

            linieDoInput.removeAttr("data-id");
            linieDoInput.removeAttr("data-name");
            linieDoInput.val("");
            linieDoInput.prop("disabled", false);

        });

        $(".liniowe-input-do").parent().click(function (e) {

            if ($(".liniowe-input-do").is(':disabled')) {
                e.preventDefault();
                showErrorOnLabel($(".liniowe-input-do"), formTranslateData.placeholder_select2);
            }

        });

        $(".liniowe-input-do").keyup(function () {
            $(".liniowe-input-do").removeAttr("data-id");
            $(".liniowe-input-do").removeAttr("data-name");

            if (lineRidesStops.filter(c => c.id === $(".liniowe-input-od").attr('data-id')).length) {
                if ($(this).val().length > 2) {
                    var sugesstionHtml = '<ul id="liniowe-input-do-suggesstion-box-list">';

                    $.each(lineRidesStops.filter(c => c.id !== $(".liniowe-input-od").attr('data-id')), function (index, row) {
                        sugesstionHtml += '<li data-id="' + row.id + '"';
                        sugesstionHtml += '>' + row.name + '</li>';
                    });
                    sugesstionHtml += "</ul>";
                    $("#liniowe-input-do-suggesstion-box").html(sugesstionHtml);
                    $("#liniowe-input-do-suggesstion-box").show();
                } else {
                    $("#liniowe-input-do-suggesstion-box").hide();
                }
            } else {
                showErrorOnLabel($(this), formTranslateData.placeholder_select2);
            }
        });


        $(document).on('click', '#liniowe-input-do-suggesstion-box-list li', function () {
            var htmlInputVal = $(this).html();
            var linieDoInput = $(".liniowe-input-do");
            $("#liniowe-input-do-suggesstion-box").hide();
            linieDoInput.val(htmlInputVal);
            linieDoInput.attr('data-id', $(this).attr('data-id'));
            linieDoInput.attr('data-name', htmlInputVal);
        });

        $(document).on('click', '#liniowe-input-passager', function () {
            $("#liniowe-input-passager-box").toggle();
        });

        $(document).on('click', '[for="with_return"]', function () {
            $('.return-input-wrapper').toggle();
        });


        $("#liniowe-form").on('submit', function (e) {
            var formBusiness = $(this);
            e.preventDefault();
            var valid = true;
            var inputElements = $(this).find("input");
            var hasPowrot = false;

            inputElements.each(function (index, element) {
                var attr = $(this).attr('name');

                if (typeof attr !== typeof undefined && attr !== false) {
                    if (attr !== "return_date") {
                        if ($(this).val() === "" || $(this).val() === null) {
                            valid = false;
                            showErrorOnLabel($(this), formTranslateData.uzupelnij_pole);
                        }

                        if (attr === "start_place" && $(this).attr('data-id') === null) {
                            valid = false;
                            showErrorOnLabel($(this), formTranslateData.uzupelnij_pole);
                        }

                        if (attr === "end_place" && $(this).attr('data-id') === null) {
                            valid = false;
                            showErrorOnLabel($(this), formTranslateData.uzupelnij_pole);
                        }
                    }

                    if (attr === "return_date" && !$('#with_return').is(':checked')) {
                        if ($(this).val() === "") {
                            valid = false;
                            showErrorOnLabel($(this), formTranslateData.uzupelnij_pole);
                        }
                    }
                } else {
                    var selectParent = $(this).parent().find("select");
                    var selectParentAttr = selectParent.attr('name');

                    if (typeof selectParentAttr !== typeof undefined && selectParentAttr !== false) {
                        if (selectParent.val() === "" || selectParent.val() === null) {
                            valid = false;
                            showErrorOnLabel(selectParent, formTranslateData.uzupelnij_pole);
                        }

                    }
                }

            });

            var linioweOdValid = $(".liniowe-input-od");

            if(typeof linioweOdValid.attr('data-id') === 'undefined'){
                valid = false;
                showErrorOnLabel(linioweOdValid, formTranslateData.uzupelnij_pole);
            }

            var linioweDoValid = $(".liniowe-input-do");
            if(typeof linioweDoValid.attr('data-id') === 'undefined'){
                valid = false;
                showErrorOnLabel(linioweDoValid, formTranslateData.uzupelnij_pole);
            }


            if (valid) {
                $("#liniowe-input-passager").val($("#liniowe-input-passager").attr("data-value"));

                var returnSerializeQuery = "";
                var serializePrefixOdDo = "";


                var linioweOd = $(".liniowe-input-od");
                //linioweOd.val(linioweOd.attr('data-id'));
                linioweOd.attr('start_place');
                serializePrefixOdDo += "start_place=" + linioweOd.attr('data-id');
                serializePrefixOdDo += "&start_place_name=" + linioweOd.val();


                var linioweDo = $(".liniowe-input-do");
                linioweDo.attr('end_place');
                //linioweDo.val(linioweDo.attr('data-id'));
                serializePrefixOdDo += "&end_place=" + linioweDo.attr('data-id');
                serializePrefixOdDo += "&end_place_name=" + linioweDo.val();
                serializePrefixOdDo += "&";


                var linioweOdjazd = $(".liniowe-odjazd");
                var dateFormat = linioweOdjazd.val();

                if (dateFormat.indexOf('.') > 1) {
                    var dateSplit = dateFormat.split(".");
                    linioweOdjazd.val(dateSplit[2] + "-" + dateSplit[1] + "-" + dateSplit[0]);
                }

                if (dateFormat.indexOf(' ') > 1) {
                    linioweOdjazd.val(linioweOdjazd.attr('data-value'));
                }


                var liniowePworot = $(".liniowe-powrot");
                var dateFormat2 = liniowePworot.val();

                if (dateFormat2 == "" || dateFormat2 == null) {
                    returnSerializeQuery = "with_return=0";
                } else {
                    returnSerializeQuery = "with_return=1";
                    if (dateFormat2.indexOf('.') > 1) {
                        var dateSplit2 = dateFormat2.split(".");
                        liniowePworot.val(dateSplit2[2] + "-" + dateSplit2[1] + "-" + dateSplit2[0]);
                    }

                    if (dateFormat2.indexOf(' ') > 1) {
                        liniowePworot.val(liniowePworot.attr('data-value'));
                    }

                }

                if ($('#with_return').is(':checked')) {
                    returnSerializeQuery = "with_return=0";
                }

                var passenger_numbers = 1;
                if($('#liniowe-input-passager').length){
                    passenger_numbers = $('#liniowe-input-passager').val();
                } else {
                    passenger_numbers = $("#liniowe-select-passager").val();
                }


                var cookieData = {
                    end_place: linioweDo.attr('data-id'),
                    end_place_name: linioweDo.val(),
                    odjazd: dateFormat,
                    powrot: dateFormat2,
                    start_place: linioweOd.attr('data-id'),
                    start_place_name: linioweOd.val(),
                    passengers_number: passenger_numbers
                };

                jQuery.cookie('liniowe_cookie', JSON.stringify(cookieData), {expires: 1});

                var document_location_href = formBusiness.attr("action") + "?" + serializePrefixOdDo + formBusiness.serialize() + "&" + returnSerializeQuery +  "&lang=" + $("body").attr('data-lang');

                //console.log(document_location_href);
                document.location.href = document_location_href;

            }
        });

        /**
         *
         * AUTOCOMPLETE BUSINESS TAXI
         *
         */

        $(".businesstaxi-input-od").keyup(debounce(function () {
            if ($(this).val().length > 2) {
                backofficeGetAutocomplete($(this).val(), function(response) {
                    var sugesstionHtml = '<ul id="businesstaxi-input-od-suggesstion-box-list">';

                    $.each(response.data, function (index, row) {
                        sugesstionHtml += '<li data-id="'+row.id+'" ';
                        if (row.start_is_airport) {
                            sugesstionHtml += ' class="airport" ';
                        }
                        sugesstionHtml += '>' + row.start_place + '</li>';
                    });

                    sugesstionHtml += "</ul>";
                    $("#businesstaxi-input-od-suggesstion-box").html(sugesstionHtml);
                    $("#businesstaxi-input-od-suggesstion-box").show();
                });
            } else {
                $("#businesstaxi-input-od-suggesstion-box").hide();
            }
        }));

        $(document).on('click', '#businesstaxi-input-od-suggesstion-box-list li', function () {
            var htmlInputVal = $(this).html();
            $("#businesstaxi-input-od-suggesstion-box").hide();
            $(".businesstaxi-input-od").val(htmlInputVal);
            $(".businesstaxi-input-od").attr("name", "start_place");


            if($(this).hasClass("airport")){
                $(".businesstaxi-input-od").attr("data-is-airport", "true");
                $(".businesstaxi-input-od").parent().attr("data-is-airport", "true");
            } else {
                $(".businesstaxi-input-od").attr("data-is-airport", "false");
                $(".businesstaxi-input-od").parent().attr("data-is-airport", "false");
            }

            var businessTaxiInput = $(".businesstaxi-input-do");

            var businessTaxiSelect = $('.businesstaxi-select-do');
            businessTaxiSelect.attr("name", 'end_place');

            businessTaxiInput.focus();

            $('.select2-dropdown--above').addClass('select2-dropdown--below');
            $('.select2-dropdown--below').removeClass('select2-dropdown--above');

            $(".businesstaxi-form-start_place_id").val($(this).data('id'));
        });


        $(".businesstaxi-input-do").keyup(debounce(function () {
            if ($(this).val().length > 2) {
                backofficeGetAutocomplete($(this).val(), function(response) {
                        var sugesstionHtml = '<ul id="businesstaxi-input-do-suggesstion-box-list">';

                        $.each(response.data, function (index, row) {
                            sugesstionHtml += '<li data-id="'+row.id+'"  ';
                            if (row.start_is_airport) {
                                sugesstionHtml += ' class="airport" ';
                            }
                            sugesstionHtml += '>' + row.start_place + '</li>';
                        });

                        sugesstionHtml += "</ul>";
                        $("#businesstaxi-input-do-suggesstion-box").html(sugesstionHtml);
                        $("#businesstaxi-input-do-suggesstion-box").show();
                    }
                );
            } else {
                $("#businesstaxi-input-do-suggesstion-box").hide();
            }
        }));

        $(document).on('click', '#businesstaxi-input-passager', function () {
            $("#businesstaxi-input-passager-box").toggle();
        });

        $(document).on('click', '.passagers-suggest-box-plus', function () {
            var thisClick = $(this);
            var dateInput = $("#" + thisClick.attr("data-input"));
            var dateAttr = thisClick.attr("data-input");

            var valueNow = dateInput.attr('data-value');

            if (valueNow === "") {
                valueNow = 1;
            } else {
                valueNow = parseInt(dateInput.attr('data-value'));
            }

            var valueNew = valueNow + 1;

            dateInput.attr("data-value", valueNew);
            var valueContent = "";

            if(dateAttr === "familytaxi-input-dzieci-passager" || dateAttr === "familytaxi-input-passager" ){

                var valueDorosli = $("#familytaxi-input-passager").attr('data-value');
                var valueDzieci  = $("#familytaxi-input-dzieci-passager").attr('data-value');

                if (valueDorosli === 1) {
                    valueContent = formTranslateData.osdorosla;
                } else {
                    valueContent = valueDorosli + formTranslateData.doroslych;
                }

                if(valueDzieci > 0){
                    valueContent += ', ';
                    if (valueDzieci === 1) {
                        valueContent += formTranslateData.dziecko;
                    } else {
                        valueContent += valueDzieci + formTranslateData.dzieci;
                    }
                }

                $("#familytaxi-input-passager").val(valueContent).trigger('change');
                dateInput.val(valueContent).trigger('change');

            } else if(dateAttr === "liniowe-input-passager"){
                if (valueNew === 1) {
                    valueContent = formTranslateData.osoba;
                } else if (valueNew > 1 && valueNew < 5) {
                    valueContent = valueNew + formTranslateData.osoby;
                } else {
                    valueContent = valueNew + formTranslateData.osob;
                }
                dateInput.val(valueContent).trigger('change');
            } else if (dateAttr === "berbus-input-dzieci-passager" || dateAttr === "berbus-input-passager") {
                var valueDorosli = $("#berbus-input-passager").attr('data-value');
                var valueDzieci  = $("#berbus-input-dzieci-passager").attr('data-value');

                if (valueDorosli === 1) {
                    valueContent = formTranslateData.osdorosla;
                } else {
                    valueContent = valueDorosli + formTranslateData.doroslych;
                }

                if(valueDzieci > 0){
                    valueContent += ', ';
                    if (valueDzieci === 1) {
                        valueContent += formTranslateData.dziecko;
                    } else {
                        valueContent += valueDzieci + formTranslateData.dzieci;
                    }
                }

                $("#berbus-input-passager").val(valueContent).trigger('change');
                dateInput.val(valueContent).trigger('change');
            }
            else {
                if (valueNew === 1) {
                    valueContent = formTranslateData.osdorosla;
                } else if (valueNew > 1 && valueNew < 5) {
                    valueContent = valueNew + formTranslateData.osdorosle;
                } else {
                    valueContent = valueNew + formTranslateData.osdoroslych;
                }
                dateInput.val(valueContent).trigger('change');
            }



            thisClick.parent().find(".passagers-suggest-box-span").html(valueNew);


            var minusDiv = thisClick.parent().find(".passagers-suggest-box-minus");
            minusDiv.addClass("active");

        });


        $(document).on('click', '.passagers-suggest-box-minus', function () {
            var changeToDisable = false;
            var thisClick = $(this);
            var dateInput = $("#" + thisClick.attr("data-input"));
            var dateAttr = thisClick.attr("data-input");


            var valueNow = dateInput.attr('data-value');

            if (valueNow === "") {
                valueNow = 1;
                changeToDisable = true;
            } else {
                valueNow = parseInt(dateInput.attr('data-value'));
            }

            var valueNew = valueNow - 1;


            if(dateAttr === "familytaxi-input-dzieci-passager" || dateAttr === "berbus-input-dzieci-passager"){

                if (valueNew < 0) {
                    valueNew = 0;
                    changeToDisable = true;
                }

                if (valueNew === 0) {
                    changeToDisable = true;
                }
            } else {
                if (valueNew < 1) {
                    valueNew = 1;
                    changeToDisable = true;
                }

                if (valueNew === 1) {
                    changeToDisable = true;
                }
            }

            dateInput.attr("data-value", valueNew);
            var valueContent = "";


            if (
              dateAttr === "familytaxi-input-dzieci-passager" ||
              dateAttr === "familytaxi-input-passager"
            ) {
                var valueDorosli = $("#familytaxi-input-passager").attr('data-value');
                var valueDzieci  = $("#familytaxi-input-dzieci-passager").attr('data-value');


                if (valueDorosli === 1) {
                    valueContent = formTranslateData.osdorosla;
                } else {
                    valueContent = valueDorosli + formTranslateData.doroslych;
                }

                if(valueDzieci > 0){
                    valueContent += ', ';
                    if (valueDzieci === 1) {
                        valueContent +=  formTranslateData.dziecko;
                    } else {
                        valueContent += valueDzieci +  formTranslateData.dzieci;
                    }
                }

             $("#familytaxi-input-passager").val(valueContent).trigger('change');
                dateInput.val(valueContent).trigger('change');

            } else if (
              dateAttr === "berbus-input-passager" ||
              dateAttr === "berbus-input-dzieci-passager"
            ) {
                var valueDorosli = $("#berbus-input-passager").attr('data-value');
                var valueDzieci  = $("#berbus-input-dzieci-passager").attr('data-value');


                if (valueDorosli === 1) {
                    valueContent = formTranslateData.osdorosla;
                } else {
                    valueContent = valueDorosli + formTranslateData.doroslych;
                }

                if (valueDzieci > 0) {
                    valueContent += ', ';
                    if (valueDzieci === 1) {
                        valueContent +=  formTranslateData.dziecko;
                    } else {
                        valueContent += valueDzieci +  formTranslateData.dzieci;
                    }
                }

                $("#berbus-input-passager").val(valueContent).trigger('change');
                dateInput.val(valueContent).trigger('change');
            } else if(dateAttr === "liniowe-input-passager"){
                if (valueNew === 1) {
                    valueContent = formTranslateData.osoba;
                } else if (valueNew > 1 && valueNew < 5) {
                    valueContent = valueNew + formTranslateData.osoby;
                } else {
                    valueContent = valueNew + formTranslateData.osob;
                }
                dateInput.val(valueContent).trigger('change');
            } else {
                if (valueNew === 1) {
                    valueContent =  formTranslateData.osdorosla;
                } else if (valueNew > 1 && valueNew < 5) {
                    valueContent = valueNew +  formTranslateData.osdorosle;
                } else {
                    valueContent = valueNew +  formTranslateData.osdoroslych;
                }
                dateInput.val(valueContent).trigger('change');
            }


            thisClick.parent().find(".passagers-suggest-box-span").html(valueNew);

            if (changeToDisable) {
                thisClick.removeClass("active");
            } else {
                thisClick.addClass("active");
            }
        });

        $(document).on('change', '.businesstaxi-select-od', function () {
            if($(".businesstaxi-select-od option:selected").hasClass("airport")){
                $(this).attr("data-is-airport", "true");
                $(this).parent().attr("data-is-airport", "true");
            } else {
                $(this).attr("data-is-airport", "false");
                $(this).parent().attr("data-is-airport", "false");
            }
        });


        $(document).on('change', '.businesstaxi-select-do', function () {
            if($(".businesstaxi-select-do option:selected").hasClass("airport")){
                $(this).attr("data-is-airport", "true");
                $(this).parent().attr("data-is-airport", "true");
            } else {
                $(this).attr("data-is-airport", "false");
                $(this).parent().attr("data-is-airport", "false");
            }
        });



        $(document).on('change', '.familytaxi-select-od', function () {
            if($(".familytaxi-select-od option:selected").hasClass("airport")){
                $(this).attr("data-is-airport", "true");
                $(this).parent().attr("data-is-airport", "true");
            } else {
                $(this).attr("data-is-airport", "false");
                $(this).parent().attr("data-is-airport", "false");
            }
        });


        $(document).on('change', '.familytaxi-select-do', function () {
            if($(".familytaxi-select-do option:selected").hasClass("airport")){
                $(this).attr("data-is-airport", "true");
                $(this).parent().attr("data-is-airport", "true");
            } else {
                $(this).attr("data-is-airport", "false");
                $(this).parent().attr("data-is-airport", "false");
            }
        });


        $(document).on('click', '#businesstaxi-input-do-suggesstion-box-list li', function () {
            var htmlInputVal = $(this).html();
            $("#businesstaxi-input-do-suggesstion-box").hide();
            $(".businesstaxi-input-do").val(htmlInputVal);
            $(".businesstaxi-input-do").attr("name", "end_place");

            if($(this).hasClass("airport")){
                $(".businesstaxi-input-do").attr("data-is-airport", "true");
                $(".businesstaxi-input-do").parent().attr("data-is-airport", "true");
            } else {
                $(".businesstaxi-input-do").attr("data-is-airport", "false");
                $(".businesstaxi-input-do").parent().attr("data-is-airport", "false");
            }

            $(".businesstaxi-form-end_place_id").val($(this).data('id'));
        });

        $(document).on('click', '#businesstaxi-zmien-button', function () {
            var btSelectOd = $(".businesstaxi-select-od");
            var btSelectDo = $(".businesstaxi-select-do");
            var btInputOd = $(".businesstaxi-input-od");
            var btInputDo = $(".businesstaxi-input-do");

            var btInputOdAttr = btInputOd.attr('name');
            var btInputDoAttr = btInputDo.attr('name');

            if (typeof btInputOdAttr !== typeof undefined && btInputOdAttr !== false) {
                // OD - INPUT
                // DO - SELECT

                var btInputOdValue = btInputOd.val();
                var btSelectDoOptions = btSelectDo.html();

                btSelectDo.select2('destroy');
                btSelectDo.addClass("nodisplay-init");
                btSelectDo.removeAttr("name");
                btSelectDo.hide();

                btSelectOd.removeClass("nodisplay-init");
                btSelectOd.attr("name", "start_place");
                btSelectOd.html(btSelectDoOptions);
                btSelectOd.show();
                createSelect2(btSelectOd);

                btInputOd.addClass("nodisplay-init");
                btInputOd.removeAttr("name");
                btInputOd.hide();

                btInputDo.removeClass("nodisplay-init");
                btInputDo.attr("name", "end_place");
                btInputDo.show();
                btInputDo.val(btInputOdValue);

                var isAirportDo = btSelectDo.parent().attr('data-is-airport');
                var isAirportOd = btSelectOd.parent().attr('data-is-airport');

                btSelectDo.parent().attr('data-is-airport', isAirportOd);
                btSelectOd.parent().attr('data-is-airport', isAirportDo);
            }


            if (typeof btInputDoAttr !== typeof undefined && btInputDoAttr !== false) {
                // DO - INPUT
                // OD - SELECT

                var btInputDoValue = btInputDo.val();
                var btSelectOdOptions = btSelectOd.html();

                btSelectOd.select2('destroy');
                btSelectOd.addClass("nodisplay-init");
                btSelectOd.removeAttr("name");
                btSelectOd.hide();

                btSelectDo.removeClass("nodisplay-init");
                btSelectDo.attr("name", "start_place");
                btSelectDo.html(btSelectOdOptions);
                btSelectDo.show();
                createSelect2(btSelectDo);

                btInputDo.addClass("nodisplay-init");
                btInputDo.removeAttr("name");
                btInputDo.hide();

                btInputOd.removeClass("nodisplay-init");
                btInputOd.attr("name", "end_place");
                btInputOd.show();
                btInputOd.val(btInputDoValue);
            }


        });


        /**
         *
         * WALIDACJA BUSINESS TAXI
         *
         */

        $("#businesstaxi-form").on('submit', function (e) {
            var formBusiness = $(this);
            e.preventDefault();
            var valid = true;
            var inputElements = $(this).find("input");

            inputElements.each(function (index, element) {
                var attr = $(this).attr('name');

                if (typeof attr !== typeof undefined && attr !== false) {
                    if ($(this).val() === "" || $(this).val() === null) {
                        valid = false;
                        showErrorOnLabel($(this), formTranslateData.uzupelnij_pole);
                    }
                } else {
                    var selectParent = $(this).parent().find("select");
                    var selectParentAttr = selectParent.attr('name');

                    if (typeof selectParentAttr !== typeof undefined && selectParentAttr !== false) {
                        if (selectParent.val() === "" || selectParent.val() === null) {
                            valid = false;
                            showErrorOnLabel(selectParent, formTranslateData.uzupelnij_pole);
                        }

                    }
                }

            });

            var btOd = $(".businesstaxi-input-od");
            var btOdAttr = btOd.attr("name");
            var btOdSelect = $(".businesstaxi-select-od").attr("name");
            if ((typeof btOdAttr === typeof undefined || btOdAttr === false) && (typeof btOdSelect === typeof undefined || btOdSelect === false)) {
                valid = false;
                showErrorOnLabel(btOd, formTranslateData.uzupelnij_pole);
            }


            var btDo = $(".businesstaxi-input-do");
            var btDoAttr = btDo.attr("name");
            var btDoSelect = $(".businesstaxi-select-do").attr("name");
            if ((typeof btDoAttr === typeof undefined || btDoAttr === false) && (typeof btDoSelect === typeof undefined || btDoSelect === false)) {
                valid = false;
                showErrorOnLabel(btDo, formTranslateData.uzupelnij_pole);
            }


            if (valid) {
                $("#businesstaxi-input-passager").val($("#businesstaxi-input-passager").attr("data-value"));
                var dateFormat = $(".businesstaxi-odjazd-value").val();

                if (dateFormat.indexOf('.') > 1) {
                    var dateSplit = dateFormat.split(".");
                    $(".businesstaxi-odjazd-value").val(dateSplit[2] + "-" + dateSplit[1] + "-" + dateSplit[0]);
                }

                var end_is_airport = "false";
                var start_is_airport = "false";

                var doIsAirport = btDo.parent().attr('data-is-airport');
                if(typeof doIsAirport !== typeof undefined && doIsAirport !== false ){
                    end_is_airport = doIsAirport;
                }

                var odIsAirport = btOd.parent().attr('data-is-airport');
                if(typeof odIsAirport !== typeof undefined && odIsAirport !== false ){
                    start_is_airport = odIsAirport;
                }

                var airport_text = "&end_is_airport=" + end_is_airport + "&start_is_airport=" + start_is_airport;


                document.location.href = formBusiness.attr("action") + "?" + formBusiness.serialize() +  airport_text + "&lang=" + $("body").attr('data-lang');

            }
        });


        /**
         *
         * AUTOCOMPLETE FAMILY TAXI
         *
         */

        $(".familytaxi-input-od").keyup(debounce(function () {
            if ($(this).val().length > 2) {
                backofficeGetAutocomplete($(this).val(), function (response) {
                    var sugesstionHtml = '<ul id="familytaxi-input-od-suggesstion-box-list">';

                    $.each(response.data, function (index, row) {
                        sugesstionHtml += '<li data-id="'+row.id+'" ';
                        if (row.start_is_airport) {
                            sugesstionHtml += ' class="airport" ';
                        }
                        sugesstionHtml += '>' + row.start_place + '</li>';
                    });

                    sugesstionHtml += "</ul>";
                    $("#familytaxi-input-od-suggesstion-box").html(sugesstionHtml);
                    $("#familytaxi-input-od-suggesstion-box").show();
                });
            } else {
                $("#familytaxi-input-od-suggesstion-box").hide();
            }
        }));


        $(".familytaxi-input-do").keyup(debounce(function () {
            if ($(this).val().length > 2) {
                backofficeGetAutocomplete($(this).val(), function (response) {
                    var sugesstionHtml = '<ul id="familytaxi-input-do-suggesstion-box-list">';

                    $.each(response.data, function (index, row) {
                        sugesstionHtml += '<li data-id="'+row.id+'" ';
                        if (row.start_is_airport) {
                            sugesstionHtml += ' class="airport" ';
                        }
                        sugesstionHtml += '>' + row.start_place + '</li>';
                    });

                    sugesstionHtml += "</ul>";
                    $("#familytaxi-input-do-suggesstion-box").html(sugesstionHtml);
                    $("#familytaxi-input-do-suggesstion-box").show();
                });
            } else {
                $("#familytaxi-input-do-suggesstion-box").hide();
            }
        }));

        $(document).on('click', '#familytaxi-input-od-suggesstion-box-list li', function () {
            $("#familytaxi-input-od-suggesstion-box").hide();
            $(".familytaxi-input-od").val($(this).html());
            $(".familytaxi-form-start_place_id").val($(this).data('id'));
        });


        $(document).on('click', '#familytaxi-zmien-button', function () {
            var fatSelectOd = $(".familytaxi-select-od");
            var fatSelectDo = $(".familytaxi-select-do");
            var fatInputOd = $(".familytaxi-input-od");
            var fatInputDo = $(".familytaxi-input-do");

            var fatInputOdAttr = fatInputOd.attr('name');
            var fatInputDoAttr = fatInputDo.attr('name');

            if (typeof fatInputOdAttr !== typeof undefined && fatInputOdAttr !== false) {
                // OD - INPUT
                // DO - SELECT

                var fatInputOdValue = fatInputOd.val();
                var fatSelectDoOptions = fatSelectDo.html();

                fatSelectDo.select2('destroy');
                fatSelectDo.addClass("nodisplay-init");
                fatSelectDo.removeAttr("name");
                fatSelectDo.hide();

                fatSelectOd.removeClass("nodisplay-init");
                fatSelectOd.attr("name", "start_place");
                fatSelectOd.html(fatSelectDoOptions);
                fatSelectOd.show();
                createSelect2(fatSelectOd);

                fatInputOd.addClass("nodisplay-init");
                fatInputOd.removeAttr("name");
                fatInputOd.hide();

                fatInputDo.removeClass("nodisplay-init");
                fatInputDo.attr("name", "end_place");
                fatInputDo.show();
                fatInputDo.val(fatInputOdValue);

                var isAiportDo = fatSelectDo.parent().attr('data-is-airport');
                var isAiportOd = fatSelectOd.parent().attr('data-is-airport');

                fatSelectDo.parent().attr('data-is-airport', isAiportOd);
                fatSelectOd.parent().attr('data-is-airport', isAiportDo);

            }


            if (typeof fatInputDoAttr !== typeof undefined && fatInputDoAttr !== false) {
                // DO - INPUT
                // OD - SELECT

                var fatInputDoValue = fatInputDo.val();
                var fatSelectOdOptions = fatSelectOd.html();

                fatSelectOd.select2('destroy');
                fatSelectOd.addClass("nodisplay-init");
                fatSelectOd.removeAttr("name");
                fatSelectOd.hide();

                fatSelectDo.removeClass("nodisplay-init");
                fatSelectDo.attr("name", "start_place");
                fatSelectDo.html(fatSelectOdOptions);
                fatSelectDo.show();
                createSelect2(fatSelectDo);

                fatInputDo.addClass("nodisplay-init");
                fatInputDo.removeAttr("name");
                fatInputDo.hide();

                fatInputOd.removeClass("nodisplay-init");
                fatInputOd.attr("name", "end_place");
                fatInputOd.show();
                fatInputOd.val(fatInputDoValue);
            }


        });


        /**
         *
         * WALIDACJA FAMILY TAXI
         *
         */

        $("#familytaxi-form").on('submit', function (e) {
            var formFamily = $(this);
            e.preventDefault();
            var valid = true;
            var inputElements = $(this).find("input");

            inputElements.each(function (index, element) {
                var attr = $(this).attr('name');

                if (typeof attr !== typeof undefined && attr !== false) {
                    if ($(this).val() === "" || $(this).val() === null) {
                        valid = false;
                        showErrorOnLabel($(this), formTranslateData.uzupelnij_pole);
                    }
                } else {
                    var selectParent = $(this).parent().find("select");
                    var selectParentAttr = selectParent.attr('name');

                    if (typeof selectParentAttr !== typeof undefined && selectParentAttr !== false) {
                        if (selectParent.val() === "" || selectParent.val() === null) {
                            valid = false;
                            showErrorOnLabel(selectParent, formTranslateData.uzupelnij_pole);
                        }

                    }
                }

            });

            var fatOd = $(".familytaxi-input-od");
            var fatOdAttr = fatOd.attr("name");
            var fatOdSelect = $(".familytaxi-select-od").attr("name");
            if ((typeof fatOdAttr === typeof undefined || fatOdAttr === false) && (typeof fatOdSelect === typeof undefined || fatOdSelect === false)) {
                valid = false;
                showErrorOnLabel(fatOd, formTranslateData.uzupelnij_pole);
            }


            var fatDo = $(".familytaxi-input-do");
            var fatDoAttr = fatDo.attr("name");
            var fatDoSelect = $(".familytaxi-select-do").attr("name");
            if ((typeof fatDoAttr === typeof undefined || fatDoAttr === false) && (typeof fatDoSelect === typeof undefined || fatDoSelect === false)) {
                valid = false;
                showErrorOnLabel(fatDo, formTranslateData.uzupelnij_pole);
            }


            if (valid) {
                $("#familytaxi-input-passager").val($("#familytaxi-input-passager").attr("data-value"));
                var dateFormat = $(".familytaxi-odjazd-value").val();

                if (dateFormat.indexOf('.') > 1) {
                    var dateSplit = dateFormat.split(".");
                    $(".familytaxi-odjazd-value").val(dateSplit[2] + "-" + dateSplit[1] + "-" + dateSplit[0]);
                }


                // PRZEROIENIE PASENTGERS

                var end_is_airport = "false";
                var start_is_airport = "false";

                var doIsAirport = fatDo.parent().attr('data-is-airport');
                if(typeof doIsAirport !== typeof undefined && doIsAirport !== false ){
                    end_is_airport = doIsAirport;
                }

                var odIsAirport = fatOd.parent().attr('data-is-airport');
                if(typeof odIsAirport !== typeof undefined && odIsAirport !== false ){
                    start_is_airport = odIsAirport;
                }

                var airport_text = "&end_is_airport=" + end_is_airport + "&start_is_airport=" + start_is_airport;

                var adult_numbers = $('#familytaxi-input-passager').attr('data-value');
                var child_numbers = $('#familytaxi-input-dzieci-passager').attr('data-value');
                var passengers_text = '&passengers_adult=' + adult_numbers + '&passengers_child=' + child_numbers;

                var document_location = formFamily.attr("action") + "?" + formFamily.not("input[name=passengers_number]").serialize() + airport_text + passengers_text + "&lang=" + $("body").attr('data-lang');


                document.location.href = document_location

            }

        });


        $(document).on('click', '#familytaxi-input-do-suggesstion-box-list li', function () {
            var htmlInputVal = $(this).html();
            $("#familytaxi-input-do-suggesstion-box").hide();
            $(".familytaxi-input-do").val(htmlInputVal);
            $(".familytaxi-input-do").attr("name", "end_place");


            if($(this).hasClass("airport")){
                $(".familytaxi-input-do").attr("data-is-airport", "true");
                $(".familytaxi-input-do").parent().attr("data-is-airport", "true");
            } else {
                $(".familytaxi-input-do").attr("data-is-airport", "false");
                $(".familytaxi-input-do").parent().attr("data-is-airport", "false");
            }

            $(".familytaxi-form-end_place_id").val($(this).data('id'));
        });


        $(document).on('click', '#familytaxi-input-od-suggesstion-box-list li', function () {
            var htmlInputVal = $(this).html();
            $("#familytaxi-input-od-suggesstion-box").hide();
            $(".familytaxi-input-od").val(htmlInputVal);
            $(".familytaxi-input-od").attr("name", "start_place");

            if($(this).hasClass("airport")){
                $(".familytaxi-input-od").attr("data-is-airport", "true");
                $(".familytaxi-input-od").parent().attr("data-is-airport", "true");
            } else {
                $(".familytaxi-input-od").attr("data-is-airport", "false");
                $(".familytaxi-input-od").parent().attr("data-is-airport", "false");
            }

            var businessTaxiInput = $(".familytaxi-input-do");

            var businessTaxiSelect = $('.familytaxi-select-do');
            businessTaxiSelect.attr("name", 'end_place');

            businessTaxiInput.focus();

            $('.select2-dropdown--above').addClass('select2-dropdown--below');
            $('.select2-dropdown--below').removeClass('select2-dropdown--above');

        });


        function createSelect2(element) {
            element.select2({
                placeholder: formTranslateData.placeholder_select2,

                "language": {
                    "noResults": function () {
                        return formTranslateData.noresults_select2;
                    }
                },
                templateResult: function (data, container) {
                    if (data.element) {
                        $(container).addClass($(data.element).attr("class"));
                    }
                    return data.text;
                }
            });

            element.trigger('change');
        }


        $(document).on('change', '.followme-frontpage-form-box-form-inputarea-col input', function () {
            $(this).parent().find('.followme-frontpage-form-input-icon').removeClass('fa-plus').addClass('fa-pencil-alt');
        });

        $(document).on('change', '.followme-frontpage-form-box-form-inputarea-col select', function () {
            $(this).parent().find('.followme-frontpage-form-input-icon').removeClass('fa-plus').addClass('fa-pencil-alt');
        });


        $(document).on('click', '#familytaxi-input-passager', function () {
            $("#familytaxi-input-passager-box").toggle();
        });


        $(document).on('click', '.godzina-suggest-box-up', function () {
            var targetElement = $("#" + $(this).attr('data-target'));
            var targetCurrentVal = parseInt(targetElement.val());

            if (targetCurrentVal > 0) {
                var newVal = targetCurrentVal - 1;
                if(targetElement.find('option[value='+newVal+']').is(':visible')){
                    targetElement.val(newVal);
                    targetElement.trigger('change');
                }
            }
        });

        $(document).on('click', '.godzina-suggest-box-down', function () {
            var targetElement = $("#" + $(this).attr('data-target'));
            var targetCurrentVal = parseInt(targetElement.val());

            if (targetCurrentVal < 23) {
                var newVal = targetCurrentVal + 1;
                if(targetElement.find('option[value='+newVal+']').is(':visible')){
                    targetElement.val(newVal);
                    targetElement.trigger('change');
                }
            }
        });


        $(document).on('click', '.minuta-suggest-box-up', function () {
            var targetElement = $("#" + $(this).attr('data-target'));
            var targetCurrentVal = parseInt(targetElement.val());

            if (targetCurrentVal > 0) {
                var newVal = targetCurrentVal - 5;
                targetElement.val(newVal);
                targetElement.trigger('change');
            }
        });

        $(document).on('click', '.minuta-suggest-box-down', function () {
            var targetElement = $("#" + $(this).attr('data-target'));
            var targetCurrentVal = parseInt(targetElement.val());

            if (targetCurrentVal < 55) {
                var newVal = targetCurrentVal + 5;
                targetElement.val(newVal);
                targetElement.trigger('change');
            }
        });


        var btHourSelect = $('#businesstaxi-hour');
        var btMinSelect = $('#businesstaxi-minutes');
        var btHourSelected = false;
        var btMinuteSelected = false;

        btHourSelect.on('change', function () {
            btHourSelected = true;
            var currrentValue = this.value;
            var addNew = parseInt(currrentValue) - 3;
            var option = btHourSelect.find("option[value=" + addNew + "]");
            var optionTop = option.offset().top;
            var selectTop = btHourSelect.offset().top;
            btHourSelect.scrollTop(btHourSelect.scrollTop() + (optionTop - selectTop));


            var currentHour = "";
            if (parseInt(btHourSelect.val()) < 10) {
                currentHour += "0" + btHourSelect.val();
            } else {
                currentHour += btHourSelect.val();
            }
            currentHour += ":";
            if (parseInt(btMinSelect.val()) < 10) {
                currentHour += "0" + btMinSelect.val();
            } else {
                currentHour += btMinSelect.val();
            }

            $(".businesstaxi-godzina").val(currentHour).trigger('change');
            if(btHourSelected && btMinuteSelected){
                $('#businesstaxi-input-godzina-box').toggle();
            }
        });

        btHourSelect.keydown(function (e) {
            if (e.which === 39) {
                btMinSelect.focus();
                e.preventDefault();
            }

            if (e.which === 13 || e.which === 9)  // the enter key code
            {
                $('.godzina-suggest-box').hide();
                $('#businesstaxi-input-passager').trigger('click');
                e.preventDefault();
                return false;
            }
        });


        btMinSelect.on('change', function () {
            btMinuteSelected = true;
            var currrentValue = this.value;
            var addNew = parseInt(currrentValue) - 15;
            var option = btMinSelect.find("option[value=" + addNew + "]");
            var optionTop = option.offset().top;
            var selectTop = btMinSelect.offset().top;
            btMinSelect.scrollTop(btMinSelect.scrollTop() + (optionTop - selectTop));

            var currentHour = "";
            if (parseInt(btHourSelect.val()) < 10) {
                currentHour += "0" + btHourSelect.val();
            } else {
                currentHour += btHourSelect.val();
            }
            currentHour += ":";
            if (parseInt(btMinSelect.val()) < 10) {
                currentHour += "0" + btMinSelect.val();
            } else {
                currentHour += btMinSelect.val();
            }

            $(".businesstaxi-godzina").val(currentHour).trigger('change');
            if(btHourSelected && btMinuteSelected){
                $('#businesstaxi-input-godzina-box').toggle();
            }
        });

        btMinSelect.keydown(function (e) {
            if (e.which === 37) {
                btHourSelect.focus();
                e.preventDefault();
            }

            if (e.which === 13 || e.which === 9)  // the enter key code
            {
                $('.godzina-suggest-box').hide();
                $('#businesstaxi-input-passager').trigger('click');
                e.preventDefault();
                return false;
            }
        });


        $(document).on('click', '#businesstaxi-input-godzina', function () {
            $("#businesstaxi-input-godzina-box").toggle();
            var businessTaxiGodzina = $("#businesstaxi-input-godzina");
            $("#businesstaxi-hour").focus();


            var btMinSelectaddNew = parseInt(btMinSelect.val()) - 15;
            var btMinSelectoption = btMinSelect.find("option[value=" + btMinSelectaddNew + "]");
            var btMinSelectoptionTop = btMinSelectoption.offset().top;
            var btMinSelectselectTop = btMinSelect.offset().top;
            btMinSelect.scrollTop(btMinSelect.scrollTop() + (btMinSelectoptionTop - btMinSelectselectTop));

            var btHourSelectaddNew = parseInt(btHourSelect.val()) - 3;
            var btHourSelectoption = btHourSelect.find("option[value=" + btHourSelectaddNew + "]");
            var btHourSelectoptionTop = btHourSelectoption.offset().top;
            var btHourSelectselectTop = btHourSelect.offset().top;
            btHourSelect.scrollTop(btHourSelect.scrollTop() + (btHourSelectoptionTop - btHourSelectselectTop));


            if (businessTaxiGodzina.val() === "") {
                var currentHour = "";
                if (parseInt(btHourSelect.val()) < 10) {
                    currentHour += "0" + btHourSelect.val();
                } else {
                    currentHour += btHourSelect.val();
                }
                currentHour += ":";
                if (parseInt(btMinSelect.val()) < 10) {
                    currentHour += "0" + btMinSelect.val();
                } else {
                    currentHour += btMinSelect.val();
                }

                businessTaxiGodzina.val(currentHour);
            }
        });


        var btHourSelect2 = $('#familytaxi-hour');
        var btMinSelect2 = $('#familytaxi-minutes');
        var fatHourSelected = false;
        var fatMinuteSelected = false;

        btHourSelect2.on('change', function () {
            fatHourSelected = true;
            var currrentValue = this.value;
            var addNew = parseInt(currrentValue) - 3;
            var option = btHourSelect2.find("option[value=" + addNew + "]");
            var optionTop = option.offset().top;
            var selectTop = btHourSelect2.offset().top;
            btHourSelect2.scrollTop(btHourSelect2.scrollTop() + (optionTop - selectTop));


            var currentHour = "";
            if (parseInt(btHourSelect2.val()) < 10) {
                currentHour += "0" + btHourSelect2.val();
            } else {
                currentHour += btHourSelect2.val();
            }
            currentHour += ":";
            if (parseInt(btMinSelect2.val()) < 10) {
                currentHour += "0" + btMinSelect2.val();
            } else {
                currentHour += btMinSelect2.val();
            }

            $(".familytaxi-godzina").val(currentHour).trigger('change');
            if(fatHourSelected && fatMinuteSelected){
                $("#familytaxi-input-godzina-box").toggle();
            }
        });

        btHourSelect2.keydown(function (e) {
            if (e.which === 39) {
                btMinSelect2.focus();
                e.preventDefault();
            }

            if (e.which === 13 || e.which === 9)  // the enter key code
            {
                $('.godzina-suggest-box').hide();
                $('#familytaxi-input-passager').trigger('click');
                e.preventDefault();
                return false;
            }
        });


        btMinSelect2.on('change', function () {
            fatMinuteSelected = true;
            var currrentValue = this.value;
            var addNew = parseInt(currrentValue) - 15;
            var option = btMinSelect2.find("option[value=" + addNew + "]");
            var optionTop = option.offset().top;
            var selectTop = btMinSelect2.offset().top;
            btMinSelect2.scrollTop(btMinSelect2.scrollTop() + (optionTop - selectTop));

            var currentHour = "";
            if (parseInt(btHourSelect2.val()) < 10) {
                currentHour += "0" + btHourSelect2.val();
            } else {
                currentHour += btHourSelect2.val();
            }
            currentHour += ":";
            if (parseInt(btMinSelect2.val()) < 10) {
                currentHour += "0" + btMinSelect2.val();
            } else {
                currentHour += btMinSelect2.val();
            }

            $(".familytaxi-godzina").val(currentHour).trigger('change');
            if(fatHourSelected && fatMinuteSelected){
                $("#familytaxi-input-godzina-box").toggle();
            }
        });

        btMinSelect2.keydown(function (e) {
            if (e.which === 37) {
                btHourSelect2.focus();
                e.preventDefault();
            }

            if (e.which === 13 || e.which === 9)  // the enter key code
            {
                $('.godzina-suggest-box').hide();
                $('#familytaxi-input-passager').trigger('click');
                e.preventDefault();
                return false;
            }
        });


        $(document).on('click', '#familytaxi-input-godzina', function () {
            $("#familytaxi-input-godzina-box").toggle();
            var familyTaxiGodzina = $("#familytaxi-input-godzin");
            $("#familytaxi-hour").focus();


            var btMinSelectaddNew = parseInt(btMinSelect2.val()) - 15;
            var btMinSelectoption = btMinSelect2.find("option[value=" + btMinSelectaddNew + "]");
            var btMinSelectoptionTop = btMinSelectoption.offset().top;
            var btMinSelectselectTop = btMinSelect2.offset().top;
            btMinSelect2.scrollTop(btMinSelect2.scrollTop() + (btMinSelectoptionTop - btMinSelectselectTop));

            var btHourSelectaddNew = parseInt(btHourSelect2.val()) - 3;
            var btHourSelectoption = btHourSelect2.find("option[value=" + btHourSelectaddNew + "]");
            var btHourSelectoptionTop = btHourSelectoption.offset().top;
            var btHourSelectselectTop = btHourSelect2.offset().top;
            btHourSelect2.scrollTop(btHourSelect2.scrollTop() + (btHourSelectoptionTop - btHourSelectselectTop));


            if (familyTaxiGodzina.val() === "") {
                var currentHour = "";
                if (parseInt(btHourSelect2.val()) < 10) {
                    currentHour += "0" + btHourSelect2.val();
                } else {
                    currentHour += btHourSelect2.val();
                }
                currentHour += ":";
                if (parseInt(btMinSelect2.val()) < 10) {
                    currentHour += "0" + btMinSelect2.val();
                } else {
                    currentHour += btMinSelect2.val();
                }

                familyTaxiGodzina.val(currentHour);
            }
        });


        $(document).mouseup(function (e) {
            var container1 = $(".passagers-suggest-box");
            var container1clicker1 = $("#familytaxi-input-passager");
            var container1clicker2 = $("#businesstaxi-input-passager");
            var container1clicker3 = $("#liniowe-input-passager");

            var container2 = $(".godzina-suggest-box");
            var container2clicker1 = $("#businesstaxi-input-godzina");
            var container2clicker2 = $("#familytaxi-input-godzina");


            var container3 = $(".liniowe-suggesstion-box");
            var container3clicker1 = $("#liniowe-input-od-suggesstion-box");
            var container3clicker2 = $("#liniowe-input-do-suggesstion-box");


            var container4 = $(".businesstaxi-suggesstion-box");
            var container4clicker1 = $("#businesstaxi-input-od-suggesstion-box");
            var container4clicker2 = $("#businesstaxi-input-do-suggesstion-box");


            var container5 = $(".familytaxi-suggesstion-box");
            var container5clicker1 = $("#familytaxi-input-od-suggesstion-box");
            var container5clicker2 = $("#familytaxi-input-do-suggesstion-box");


            if (!container1.is(e.target) && container1.has(e.target).length === 0 && !container1clicker1.is(e.target) && !container1clicker2.is(e.target) && !container1clicker3.is(e.target)) {
                container1.hide();
            }


            if (!container2.is(e.target) && container2.has(e.target).length === 0 && !container2clicker1.is(e.target) && !container2clicker2.is(e.target)) {
                container2.hide();
            }

            if (!container3.is(e.target) && container3.has(e.target).length === 0 && !container3clicker1.is(e.target) && !container3clicker2.is(e.target)) {
                container3.hide();
            }

            if (!container4.is(e.target) && container4.has(e.target).length === 0 && !container4clicker1.is(e.target) && !container4clicker2.is(e.target)) {
                container4.hide();
            }

            if (!container5.is(e.target) && container5.has(e.target).length === 0 && !container5clicker1.is(e.target) && !container5clicker2.is(e.target)) {
                container5.hide();
            }

        });
    });

    function showErrorOnLabel(jQInputElement, errorText) {
        var labelElement = jQInputElement.parent().find("label");
        var oldLabelName = "";
        oldLabelName = labelElement.html();

        labelElement.css('opacity', '1');
        labelElement.addClass("error");
        labelElement.html(errorText);

        setTimeout(function () {
            labelElement.removeClass("error");
            labelElement.html(oldLabelName);
            labelElement.css('opacity', '0.6');
        }, 4000);

    }

    /**
     *
     * BERBUS
     *
     */

    function debounce(callback, ms = 500) {
        var timer = 0;
        return function() {
            var context = this, args = arguments;
            clearTimeout(timer);
            timer = setTimeout(function () {
                callback.apply(context, args);
            }, ms || 0);
        };
    }

    const debounceTime = 500;

    $("#berbus-form").on('submit', function (e) {
        var formFamily = $(this);
        e.preventDefault();
        var valid = true;
        var inputElements = $(this).find("input");

        inputElements.each(function (index, element) {
            var attr = $(this).attr('name');

            if (typeof attr !== typeof undefined && attr !== false) {
                if ($(this).val() === "" || $(this).val() === null) {
                    valid = false;
                    showErrorOnLabel($(this), formTranslateData.uzupelnij_pole);
                }
            } else {
                var selectParent = $(this).parent().find("select");
                var selectParentAttr = selectParent.attr('name');

                if (typeof selectParentAttr !== typeof undefined && selectParentAttr !== false) {
                    if (selectParent.val() === "" || selectParent.val() === null) {
                        valid = false;
                        showErrorOnLabel(selectParent, formTranslateData.uzupelnij_pole);
                    }
                }
            }
        });

        var berbusOd = $(".berbus-input-od");
        var berbusOdAttr = berbusOd.attr("name");
        var berbusOdSelect = $(".berbus-select-od").attr("name");
        if ((typeof berbusOdAttr === typeof undefined || berbusOdAttr === false) && (typeof berbusOdSelect === typeof undefined || berbusOdSelect === false)) {
            valid = false;
            showErrorOnLabel(berbusOd, formTranslateData.uzupelnij_pole);
        }


        var berbusDo = $(".berbus-input-do");
        var berbusDoAttr = berbusDo.attr("name");
        var berbusDoSelect = $(".berbus-select-do").attr("name");
        if ((typeof berbusDoAttr === typeof undefined || berbusDoAttr === false) && (typeof berbusDoSelect === typeof undefined || berbusDoSelect === false)) {
            valid = false;
            showErrorOnLabel(berbusDo, formTranslateData.uzupelnij_pole);
        }


        if (valid) {
            $("#berbus-input-passager").val($("#berbus-input-passager").attr("data-value"));
            var dateFormat = $(".berbus-odjazd-value").val();

            if (dateFormat.indexOf('.') > 1) {
                var dateSplit = dateFormat.split(".");
                $(".berbus-odjazd-value").val(dateSplit[2] + "-" + dateSplit[1] + "-" + dateSplit[0]);
            }


            var end_is_airport = "false";
            var start_is_airport = "false";

            var doIsAirport = berbusDo.parent().attr('data-is-airport');
            if(typeof doIsAirport !== typeof undefined && doIsAirport !== false ){
                end_is_airport = doIsAirport;
            }

            var odIsAirport = berbusOd.parent().attr('data-is-airport');
            if(typeof odIsAirport !== typeof undefined && odIsAirport !== false ){
                start_is_airport = odIsAirport;
            }

            var airport_text = "&end_is_airport=" + end_is_airport + "&start_is_airport=" + start_is_airport;

            var adult_numbers = $('#berbus-input-passager').attr('data-value');
            var child_numbers = $('#berbus-input-dzieci-passager').attr('data-value');
            var passengers_text = '&passengers_adult=' + adult_numbers + '&passengers_child_age_3=' + child_numbers;

            var document_location = formFamily.attr("action") + "?" + formFamily.not("input[name=passengers_number]").serialize() + airport_text + passengers_text + "&lang=" + $("body").attr('data-lang');


            document.location.href = document_location

        }

    });

    $(document).on('click', '#berbus-input-godzina', function () {
        if(!$(".berbus-input-od").val()){
            showErrorOnLabel($('.berbus-input-od'), formTranslateData.uzupelnij_pole);
            return false;
        }

        $("#berbus-input-godzina-box").toggle();
        var berbusGodzina = $("#berbus-input-godzin");
        $("#berbus-hour").focus();


        var berbusMinSelectaddNew = parseInt(berbusMinSelect2.val());
        var berbusMinSelectoption = berbusMinSelect2.find("option[value=" + berbusMinSelectaddNew + "]");
        var berbusMinSelectoptionTop = berbusMinSelectoption.offset().top;
        var berbusMinSelectselectTop = berbusMinSelect2.offset().top;
        berbusMinSelect2.scrollTop(berbusMinSelect2.scrollTop() + (berbusMinSelectoptionTop - berbusMinSelectselectTop));

        var berbusHourSelectaddNew = parseInt(berbusHourSelect2.val()) - 3;
        var berbusHourSelectoption = berbusHourSelect2.find("option[value=" + berbusHourSelectaddNew + "]");
        var berbusHourSelectoptionTop = berbusHourSelectoption.offset().top;
        var berbusHourSelectselectTop = berbusHourSelect2.offset().top;
        berbusHourSelect2.scrollTop(berbusHourSelect2.scrollTop() + (berbusHourSelectoptionTop - berbusHourSelectselectTop));


        if (berbusGodzina.val() === "") {
            var currentHour = "";
            if (parseInt(berbusHourSelect2.val()) < 10) {
                currentHour += "0" + berbusHourSelect2.val();
            } else {
                currentHour += berbusHourSelect2.val();
            }
            currentHour += ":";
            if (parseInt(berbusMinSelect2.val()) < 10) {
                currentHour += "0" + berbusMinSelect2.val();
            } else {
                currentHour += berbusMinSelect2.val();
            }

            berbusGodzina.val(currentHour);
        }
    });

    var berbusHourSelect2 = $('#berbus-hour');
    var berbusMinSelect2 = $('#berbus-minutes');
    var berbusHourSelected = false;
    var berbusMinuteSelected = false;

    berbusHourSelect2.on('change', function () {
        berbusHourSelected = true;
        var currrentValue = this.value;
        var addNew = parseInt(currrentValue);
        var option = berbusHourSelect2.find("option[value=" + addNew + "]");
        var optionTop = option.offset().top;
        var selectTop = berbusHourSelect2.offset().top;
        berbusHourSelect2.scrollTop(berbusHourSelect2.scrollTop() + (optionTop - selectTop));


        var currentHour = "";
        if (parseInt(berbusHourSelect2.val()) < 10) {
            currentHour += "0" + berbusHourSelect2.val();
        } else {
            currentHour += berbusHourSelect2.val();
        }
        currentHour += ":";
        if (parseInt(berbusMinSelect2.val()) < 10) {
            currentHour += "0" + berbusMinSelect2.val();
        } else {
            currentHour += berbusMinSelect2.val();
        }

        $(".berbus-godzina").val(currentHour).trigger('change');
        if(berbusHourSelected && berbusMinuteSelected){
            $("#berbus-input-godzina-box").toggle();
        }
    });

    berbusHourSelect2.keydown(function (e) {
        if (e.which === 39) {
            berbusMinSelect2.focus();
            e.preventDefault();
        }

        if (e.which === 13 || e.which === 9)  // the enter key code
        {
            $('.godzina-suggest-box').hide();
            $('#berbus-input-passager').trigger('click');
            e.preventDefault();
            return false;
        }
    });


    berbusMinSelect2.on('change', function () {
        berbusMinuteSelected = true;
        var currrentValue = this.value;
        var addNew = parseInt(currrentValue);
        var option = berbusMinSelect2.find("option[value=" + addNew + "]");
        var optionTop = option.offset().top;
        var selectTop = berbusMinSelect2.offset().top;
        berbusMinSelect2.scrollTop(berbusMinSelect2.scrollTop() + (optionTop - selectTop));

        var currentHour = "";
        if (parseInt(berbusHourSelect2.val()) < 10) {
            currentHour += "0" + berbusHourSelect2.val();
        } else {
            currentHour += berbusHourSelect2.val();
        }
        currentHour += ":";
        if (parseInt(berbusMinSelect2.val()) < 10) {
            currentHour += "0" + berbusMinSelect2.val();
        } else {
            currentHour += berbusMinSelect2.val();
        }

        $(".berbus-godzina").val(currentHour).trigger('change');
        if(berbusHourSelected && berbusMinuteSelected){
            $("#berbus-input-godzina-box").toggle();
        }
    });

    berbusMinSelect2.keydown(function (e) {
        if (e.which === 37) {
            berbusHourSelect2.focus();
            e.preventDefault();
        }

        if (e.which === 13 || e.which === 9)  // the enter key code
        {
            $('.godzina-suggest-box').hide();
            $('#berbus-input-passager').trigger('click');
            e.preventDefault();
            return false;
        }
    });

    $(document).on('click', '#berbus-input-passager', function () {
        $("#berbus-input-passager-box").toggle();
    });

    function setupBerbusDepartureTime() {
        const berbusInputOd = $(".berbus-input-od");
        const berbusInputOdValue = berbusInputOd.val();
        const hourFrom = berbusInputOd.attr('data-hour-from');
        const hourTo = berbusInputOd.attr('data-hour-to');
        const departureTimeInput = $('#berbus-input-godzina');

        departureTimeInput.val('');
        showBerbusHourRange();
        if(hourFrom && hourTo){
            showBerbusHourRange(hourFrom, hourTo);
        }
        else{
            googleFindAddressGeo(berbusInputOdValue).then((addresses) => {
                const address = addresses[0];
                $.ajax({
                    type: "GET",
                    url: formTranslateConfigs.berbus_url + "api/travel/berbus/zone",
                    data: {lat: address.geometry.location.lat(), lng: address.geometry.location.lng()},
                    beforeSend: function () {
                    },
                    success: function (response) {
                        showBerbusHourRange(response.data.hour_from, response.data.hour_to);
                    }
                });
            });
        }
    }

    function showBerbusHourRange(from = null, to = null) {
        const select = $('#berbus-hour');
        const options = select.find('option');
        const from_int = getHourPartOfForDepartureTime(from);
        const to_int = getHourPartOfForDepartureTime(to);

        options.show();
        if(from === null || to === null){
            return;
        }

        options.each(function(index, option){
            if(option.value < from_int || option.value > to_int){
                $(option).hide();
            }
        });
    }

    function googleFindAddressGeo(address) {
        const geocoder = new window.google.maps.Geocoder();
        return new Promise((resolve, reject) => {
            geocoder.geocode({
                address,
                bounds: new window.google.maps.LatLngBounds(
                    new window.google.maps.LatLng(53.33, 14.40),
                    new window.google.maps.LatLng(53.53, 14.72)
                ),
            }, (results, status) => {
                if (status !== 'OK') {
                    reject();
                }
                if (results.length === 0) {
                    reject();
                }
                resolve(results);
            });
        });
    }

    function getHourPartOfForDepartureTime(time) {
        return time ? parseInt(time.replace(/:.*?$/, ''), 10) : null;
    }

    $(document).on('click', '#berbus-input-od-suggesstion-box-list li', function () {
        var htmlInputVal = $(this).html();
        $("#berbus-input-od-suggesstion-box").hide();
        $(".berbus-input-od").val(htmlInputVal);
        $(".berbus-input-od").attr("name", "start_address");

        $("#berbus-start-vendor").val($(this).attr("vendor"));

        if($(this).hasClass("airport")){
            $(".berbus-input-od").attr("data-is-airport", "true");
            $(".berbus-input-od").parent().attr("data-is-airport", "true");
        } else {
            $(".berbus-input-od").attr("data-is-airport", "false");
            $(".berbus-input-od").parent().attr("data-is-airport", "false");
        }

        $(".berbus-input-od").attr("data-hour-from", null);
        $(".berbus-input-od").attr("data-hour-to", null);

        $('.select2-dropdown--above').addClass('select2-dropdown--below');
        $('.select2-dropdown--below').removeClass('select2-dropdown--above');

        // setupBerbusDepartureTime();
    });

    $(".berbus-input-od").keyup(debounce(function (e) {
        const mapsService = new google.maps.places.AutocompleteService();

        var start_place = $(this).val();
        if (start_place.length > 2) {
            var suggestionBox = $("#berbus-input-od-suggesstion-box");
            suggestionBox.html(
                '<ul id="berbus-input-od-suggesstion-box-list"></ul>'
            );
            var list = $("#berbus-input-od-suggesstion-box-list");

            backofficeGetAutocomplete(start_place, function(response){
                const data = response.data.reverse()
                $.each(data, function (index, row) {
                    var suggestionHtml = '<li data-hour-from="'+row.hour_from+'" data-hour-to="'+row.hour_to+'"';
                    if (row.start_is_airport) {
                        suggestionHtml += ' class="airport" ';
                        suggestionHtml += ' vendor="local">';
                    }
                    else{
                        suggestionHtml += ' vendor="gmaps">';
                    }
                    suggestionHtml += row.start_place + '</li>';
                    list.prepend(suggestionHtml);
                });
            });

            suggestionBox.show();
        } else {
            $("#berbus-input-od-suggesstion-box").hide();
        }
    }, debounceTime));

    $(document).on('click', '#berbus-input-do-suggesstion-box-list li', function () {
        var htmlInputVal = $(this).html();
        $("#berbus-input-do-suggesstion-box").hide();
        $(".berbus-input-do").val(htmlInputVal);
        $(".berbus-input-do").attr("name", "end_address");

        $("#berbus-end-vendor").val($(this).attr("vendor"));

        if($(this).hasClass("airport")){
            $(".berbus-input-do").attr("data-is-airport", "true");
            $(".berbus-input-do").parent().attr("data-is-airport", "true");
        } else {
            $(".berbus-input-do").attr("data-is-airport", "false");
            $(".berbus-input-do").parent().attr("data-is-airport", "false");
        }

        $(".berbus-input-do").attr("data-hour-from", null);
        $(".berbus-input-do").attr("data-hour-to", null);
    });

    $(".berbus-input-do").keyup(debounce(function () {
        const mapsService = new google.maps.places.AutocompleteService();

        var end_place = $(this).val()
        if (end_place.length > 2) {
            var suggestionBox = $("#berbus-input-do-suggesstion-box");
            suggestionBox.html(
                '<ul id="berbus-input-do-suggesstion-box-list"></ul>'
            );
            var list = $("#berbus-input-do-suggesstion-box-list");

            backofficeGetAutocomplete(end_place, function(response){
                const data = response.data.reverse()
                $.each(data, function (index, row) {
                    var suggestionHtml = '<li data-hour-from="'+row.hour_from+'" data-hour-to="'+row.hour_to+'"';
                    if (row.start_is_airport) {
                        suggestionHtml += ' class="airport" ';
                        suggestionHtml += ' vendor="local">';
                    }
                    else{
                        suggestionHtml += ' vendor="gmaps">';
                    }
                    suggestionHtml += row.start_place + '</li>';
                    list.prepend(suggestionHtml);
                });
            });

            suggestionBox.show();
        } else {
            $("#berbus-input-do-suggesstion-box").hide();
        }
    }, debounceTime));

    $(document).on('click', '#berbus-zmien-button', function () {
        const berbusInputOd = $(".berbus-input-od");
        const berbusInputDo = $(".berbus-input-do");
        const berbusStartVendorInput = $("#berbus-start-vendor");
        const berbusEndVendorInput = $("#berbus-end-vendor");

        const berbusInputOdValue = berbusInputOd.val();
        const berbusInputDoValue = berbusInputDo.val();
        const berbusStartVendorValue = berbusStartVendorInput.val();
        const berbusEndVendorValue = berbusEndVendorInput.val();
        const hourFromOd = berbusInputOd.attr("data-hour-from");
        const hourToOd = berbusInputOd.attr("data-hour-to");

        berbusInputOd.val(berbusInputDoValue);
        berbusInputDo.val(berbusInputOdValue);
        berbusStartVendorInput.val(berbusEndVendorValue)
        berbusEndVendorInput.val(berbusStartVendorValue)

        berbusInputOd.attr("data-hour-from", berbusInputDo.attr("data-hour-from"));
        berbusInputOd.attr("data-hour-to", berbusInputDo.attr("data-hour-to"));
        berbusInputDo.attr("data-hour-from", hourFromOd);
        berbusInputDo.attr("data-hour-to", hourToOd);

        // setupBerbusDepartureTime();
    });

})(jQuery);
